import { MakeCall } from 'ha/services/apiV2/createMakeCall';

interface Payload {
  reason: string;
}

export default (makeCall: MakeCall) => (userId: number, data: Payload) =>
  makeCall<undefined>('POST', `/api/v2/user/${userId}/report`, { data });
